<template>
  <div class="qr-scanner">


    <button @click="startScanner" v-if="!scanning">
      Scannen
    </button>

    <button @click="stopScanner" v-if="scanning">
      Abbrechen
    </button>
    <video ref="video" class="video"></video>
  </div>
</template>

<script>
import QrScanner from "qr-scanner";

export default {
  name: "QrScanner",

  data() {
    return {
      scanner: null,
      scanning: false,
      result: null,
    };
  },

  methods: {
    async startScanner() {
      this.scanner = new QrScanner(
        this.$refs.video,
        (result) => {
          console.log("QR erkannt:", result);

          // Scanner stoppen
          this.stopScanner();

          try{
            this.result = result.data || result;
            const extract = this.result.match(/\[([^\]]*)\]/)[1];
            console.log("Extrahierte Zahl:", extract);
            this.result = extract;
            this.$emit('scanned', this.result); 
          } catch (err){
            this.$emit('scanError', this.result); 
          }
        },
        {
          returnDetailedScanResult: true,
          highlightScanRegion: true,
          highlightCodeOutline: true,
        }
      );

      try {
        await this.scanner.start();
        this.scanning = true;
      } catch (err) {
        console.error("Kamera konnte nicht gestartet werden:", err);
      }
    },

    async stopScanner() {
      if (this.scanner) {
        await this.scanner.stop();
        this.scanning = false;
        this.scanner.destroy();
        this.scanner = null;
      }
    },
  },

  beforeDestroy() {
    if (this.scanner) {
      this.scanner.destroy();
    }
  },
};
</script>

<style scoped>
.qr-scanner {
  max-width: 500px;
  width: 95%;
  margin: auto;
  text-align: center;
}

.video {
  max-width: 500px;
  width: 95%;
  border-radius: 12px;
  background: #000;
}

.result {
  margin-top: 20px;
  background: #f4f4f4;
  border-radius: 8px;
}

button{
  margin-left : auto;
  margin-right : auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 0.5em;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
  width: 95%;

  font: bold 18px sans-serif;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #7ed698;
  cursor: pointer;
}

button:hover{
  background-color: #6fb985;;
}
button:active{
  background-color: #6fb985;;
  box-shadow: 2px 2px 5px transparent;
}
</style>